module.exports = __webpack_public_path__ + "img/37782-031.2ee3a290.jpg";